import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-876b323a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name"]
const _hoisted_2 = {
  key: 0,
  class: "icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['tab-button', { selected: _ctx.selected }]),
    name: _ctx.name,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.value)))
  }, [
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}